import NewSubject from './NewSubject'
import BankAccount from './BankAccount'
import CurrencySelect from './CurrencySelect'

export default class Subject {
  constructor(component) {
    this.component = component
  }
  name() {
    return 'subject'
  }
  handle(event) {
    if(event.back) {
      this.component.modalExpanded = false
      this.component.transaction_controller.operation = null
      this.component.transaction_controller = new CurrencySelect(this.component)
      return
    }
    if(event.newSubject) {
      this.component.modalExpanded = true
      this.component.transaction_controller = new NewSubject(this.component, event.isCnpj)
      return
    }
    if(event.selectedSubject) {
      this.component.selected_subject = event.selectedSubject
      this.component.modalExpanded = false
      this.component.transaction_controller = new BankAccount(this.component)
      return
    }
    if(event.setSubject) {
      this.component.selected_subject = event.setSubject
      return
    }
    if(event.resetSubject) {
      this.component.selected_subject = null
      return
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/NewTransaction/Subject.js